import { z } from 'zod';
/**
 * Legal documents store + acceptance archive (BP-22, D-145). Every legal document version ever shown
 * is stored immutably server-side; these shapes serve the Settings "Your accepted terms" archive, the
 * consent gates (which render their text from the store), the supplier portal "What you accepted"
 * view, and the public /legal/* pages.
 */
export const legalDocTypeSchema = z.enum(['customer_terms', 'supplier_portal_notice', 'privacy_policy', 'subprocessor_list', 'template_disclaimer']);
/** GET /legal-documents/:docType/:version (auth) and GET /legal/:docType (public, current only). */
export const legalDocumentSchema = z.object({
    docType: legalDocTypeSchema,
    version: z.string(),
    title: z.string(),
    effectiveDate: z.string().nullable(),
    bodyMd: z.string(),
    sha256: z.string(),
    current: z.boolean(),
});
/** GET /me/terms-acceptances — the signed-in user's own acceptance history, newest first. */
export const termsAcceptanceSchema = z.object({
    docType: legalDocTypeSchema,
    version: z.string(),
    channel: z.string(),
    acceptedAt: z.string(),
    current: z.boolean(),
});
/** GET /portal/:token/consent-document — what this invite accepted, plus the current notice. */
export const portalConsentDocumentSchema = z.object({
    orgName: z.string(),
    supplierName: z.string(),
    acceptedVersion: z.string().nullable(),
    acceptedAt: z.string().nullable(),
    /** The exact text of the version this invite accepted (null until consent is recorded). */
    accepted: legalDocumentSchema.nullable(),
    /** The version currently in force (what a re-prompt would show). */
    current: legalDocumentSchema,
});
//# sourceMappingURL=legal.js.map